import apiClient from '@/services/axios'

export async function patch(bookingId, arrivalState) {
  var arrivalStateRequest = {
    "arrivalState": arrivalState
  }

  var response = await apiClient.patch(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/bookings/' + bookingId + '/arrival-state', arrivalStateRequest);

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to patch arrival state.')
}
